import { ChevronLeft, ChevronRight } from "@components/Icons"
import { Box } from "@components/Layout"
import { ChoicesArticle } from "@generated"
import { useWindowSize } from "@lib/useWindowSize"
import { useVirtualizer } from "@tanstack/react-virtual"
import React, { useEffect, useRef } from "react"
import Slide from "./Slide"
import * as S from "./Slide.elements"

interface Props {
  activeIndex: number
  onClickPrev: () => void
  onClickNext: () => void
  onClickItem: (index: number) => void
  items: ChoicesArticle[]
  canMovePrev: boolean
  canMoveNext: boolean
}

export const MobileCarousel: React.FC<Props> = ({
  activeIndex,
  onClickNext,
  onClickPrev,
  onClickItem,
  items,
  canMovePrev,
  canMoveNext,
}) => {
  const { width } = useWindowSize()
  const slideWidth = (width * 0.95) / 4
  const ref = useRef()
  const rowVirtualizer = useVirtualizer({
    count: items.length,
    horizontal: true,
    getScrollElement: () => ref.current,
    estimateSize: () => slideWidth,
    overscan: 100,
    paddingStart: width * 0.025,
    paddingEnd: width * 0.025,
  })

  useEffect(() => {
    rowVirtualizer.scrollToIndex(activeIndex, { align: "auto" })
  }, [activeIndex, rowVirtualizer])

  return (
    <>
      <div
        style={{
          overflow: "auto",
          width: "100vw",
          position: "relative",
          height: 140,
        }}
        ref={ref}
      >
        <div
          style={{
            position: "relative",
            scrollBehavior: "smooth",
            height: 140,
            width: `${rowVirtualizer.getTotalSize()}px`,
          }}
        >
          {rowVirtualizer.getVirtualItems().map((column) => {
            const isActive = column.key === activeIndex
            const item = items[column.index]

            return (
              <div
                key={column.key}
                data-index={column.index}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  width: `${slideWidth}px`,
                  transform: `translateX(${column.start}px)`,
                }}
              >
                {item && (
                  <Slide
                    id={item.id}
                    name={item.name}
                    onClick={() => onClickItem(column.index)}
                    isCurrent={isActive}
                  />
                )}
              </div>
            )
          })}
        </div>
      </div>
      <Box
        height="100%"
        display="flex"
        alignItems="flex-end"
        position="relative"
      >
        <S.NavButtons>
          {canMovePrev && (
            <S.NavButton onClick={onClickPrev}>
              <ChevronLeft />
            </S.NavButton>
          )}
          {canMoveNext && (
            <S.NavButton onClick={onClickNext}>
              <ChevronRight />
            </S.NavButton>
          )}
        </S.NavButtons>
      </Box>
    </>
  )
}

export default MobileCarousel
